import React, { useState, useMemo } from 'react'

import { cloneDeep } from 'lodash/lang'
import { validatePasswordRequirements } from 'components/shared/PasswordFieldWithRequirements'

const withState = WrappedComponent => {
  return props => {
    const {
      queryLoading, // via withQuery
      setAccountForm, // via redux actions
      form // via withRedux
    } = props

    const [formLoading, setFormLoading] = useState(true)
    const [token, setToken] = useState()

    const initialFormValues = {
      // preferences attributes
      onlineOnly: false,
      // account attributes
      email: '',
      password: '',
      // form-only attributes
      passwordConfirmation: '',
      // parent attributes
      firstName: '',
      lastName: '',
      relationshipToCampers: '',
      legalGuardian: '',
      primaryPhone: '',
      alternatePhone: '',
      streetAddress: '',
      city: '',
      region: '',
      country: 'US',
      postalCode: '',
      primaryPhoneType: 'mobile',
      smsOptIn: false
    }

    if (formLoading && !queryLoading) {
      setAccountForm(cloneDeep(initialFormValues))
      setFormLoading(false)
    }

    // Check if password meets all requirements
    const passwordRequirementsMet = useMemo(() => {
      return validatePasswordRequirements(form?.password)
    }, [form?.password])

    return (
      <WrappedComponent
        formLoading={formLoading}
        token={token}
        setToken={setToken}
        passwordRequirementsMet={passwordRequirementsMet}
        {...props}
      />
    )
  }
}

export default withState
